import { render, staticRenderFns } from "./NewDiscountCouponSidebar.vue?vue&type=template&id=52f9d061"
import script from "./NewDiscountCouponSidebar.vue?vue&type=script&lang=js"
export * from "./NewDiscountCouponSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports